import { HashRouter, Route, Routes } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ConsignmentList } from '../pages/Consignment/ConsignmentList';
import CreateConsignment from '../pages/Consignment/CreateConsignment';
import OrderBulkUpload from '../pages/Consignment/OrderBulkUpload';
import EditConsignment from '../pages/Consignment/EditConsignment';

import {
  ClientAccessControl,
  PermissionRequired,
} from '@careinfo/permission-required';
export const queryClient = new QueryClient();

const Router = () => {
  return (
    <QueryClientProvider client={queryClient}>
      <HashRouter>
        <Routes>
          <Route
            path={'/'}
            element={
              <ClientAccessControl
                children={<ConsignmentList />}
                allowedPermissions={['can_view_merchant_consignment']}
                renderNoAccess={<PermissionRequired />}
              />
            }
          />
          <Route
            path={'/create'}
            element={
              <ClientAccessControl
                children={<CreateConsignment />}
                allowedPermissions={['can_create_merchant_consignment']}
                renderNoAccess={<PermissionRequired />}
              />
            }
          />
          <Route path={'/bulk-upload'} element={<OrderBulkUpload />} />
          <Route
            path={'/edit/:id'}
            element={
              <ClientAccessControl
                children={<EditConsignment />}
                allowedPermissions={['can_editupdate_merchant_consignment']}
                renderNoAccess={<PermissionRequired />}
              />
            }
          />
        </Routes>
      </HashRouter>
      <ToastContainer autoClose={500} draggablePercent={30} />
    </QueryClientProvider>
  );
};

export default Router;
